export class DateHelper {
  public static readonly dbMinDate = '0001-01-01T00:00:00';
}
